<div class="editor-content">
  @if (editMode) {
    <pr-content-editor
      [required]="required"
      [menuEnabled]="isHTMLTemplate$ | async"
      [ngClass]="{ 'editor-padding': (isHTMLTemplate$ | async) === false }"
      [formControl]="formControl"
    />
  } @else {
    <pr-template-preview
      [template]="formControl.value"
      [context]="context$ | async"
      [type]="templateType$ | async"
    />
  }
</div>
@if ((isHTMLTemplate$ | async) === false) {
  <pt-sms-segment-counter
    class="block text-right text-sm opacity-50"
    [formCtrl]="formControl"
  />
}
<div class="flex gap-4 px-2 pt-2">
  <ng-content />
  <div class="flex-1">
    <a
      mat-button
      color="primary"
      [matTooltip]="templateVariablesTooltip"
      (click)="openContextPreviewDialog()"
    >
      Personalise your message with template variables
    </a>
  </div>

  @if (editMode) {
    <a mat-button color="primary" (click)="editMode = false">Preview</a>
  } @else {
    <a mat-button color="primary" (click)="editMode = true">Edit</a>
  }
</div>
